import { useSession } from '@components/app/Session';
import { useConfigLink } from '@domain/app';
import useBankAllowedOperations from '@hooks/use-bank-allowed-operations';
import useText from '@hooks/use-text';
import { getCreditCardApplicationUrl } from '@utils/url/get-url-utils';

export const useOrderNewCreditCardUrl = () => {
    const { canOrderCard } = useBankAllowedOperations();
    const session = useSession();
    const text = useText();

    if (!canOrderCard) {
        return undefined;
    }

    return getCreditCardApplicationUrl(session, text);
};

export const useKbOrderNewCreditCardUrl = () => {
    const { canOrderCard } = useBankAllowedOperations();
    const { url: orderNewCreditCardUrl } = useConfigLink('creditCardApplicationUrl');

    if (!canOrderCard) {
        return undefined;
    }

    return orderNewCreditCardUrl;
};
